import { render, staticRenderFns } from "./NorskOrdbankResultBlocks.vue?vue&type=template&id=ccceaf4a&"
import script from "./NorskOrdbankResultBlocks.vue?vue&type=script&lang=js&"
export * from "./NorskOrdbankResultBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports